import axios,{buildApi} from '@/libs/api.request'

export const apis = buildApi({
	get:['/finance/currency&getCurrency'],
})

// 获取列表
export const getCurrency = (params) => {
  return axios.request({
    url: '/finance/currency',
    method: 'get',
    params
  })
}
// 创建列表
export const add = (data) => {
  return axios.request({
    url: '/finance/currency',
    data,
    method: 'post'
  })
}
// 获取详情
export const getDetails = (id) => {
  return axios.request({
    url: `/finance/currency/${id}`,
    method: 'GET'
  })
}
// 更新列表
export const update = (data) => {
  return axios.request({
    url: `/finance/currency/${data.id}`,
    method: 'put',
    data
  })
}

// 删除列表
export const del = (id) => {
  return axios.request({
    url: `/finance/currency/${id}`,
    method: 'DELETE'
  })
}

// 汇率
export const ratePut = (data) => {
  return axios.request({
    url: `/finance/currency/${data.id}/${data.type}`,
    method: 'put',
    data
  })
}